import { Location } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NavbarComponent } from './components/navbar/navbar.component';
import { FooterComponent } from './components/footer/footer.component';
import { CookieBannerComponent } from './components/cookie-banner/cookie-banner.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [RouterOutlet, NavbarComponent, FooterComponent, NgxSpinnerModule, CookieBannerComponent]
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  // Prima della navigazione iniziale router.url è ancora "/": la navbar
  // verrebbe creata e partirebbe la chiamata authorizations.
  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
      startWith(this.location.path()),
    ),
    { initialValue: this.location.path() },
  );

  readonly showShell = computed(() => {
    const path = this.currentUrl().split('?')[0].split('#')[0];
    return path !== '/pagamenti' && !path.startsWith('/pagamenti/');
  });

  title = 'Archivio Misericordia Borgo San Lorenzo';
  constructor(private titleService: Title, private metaService: Meta) {
    this.setStaticSEO();
    // Porta in cima subito all'inizio della navigazione, senza animazione,
    // così la nuova pagina compare già in alto (non dopo un delay/scroll).
    this.router.events
      .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart))
      .subscribe(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      });
  }

  setStaticSEO() {
    // Aggiorna titolo della pagina
    this.titleService.setTitle('Archivio Misericordia Borgo San Lorenzo');

    // Aggiorna meta tag
    this.metaService.addTags([
      { name: 'description', content: 'Scopri la storia e i documenti dell\'Archivio della Misericordia di Borgo San Lorenzo.' },
      { name: 'keywords', content: 'archivio misericordia borgo san lorenzo, documenti storici, archivio storico' },
      { property: 'og:title', content: 'Archivio Storico Misericordia Borgo San Lorenzo' },
      { property: 'og:description', content: 'Documenti storici e memoria della comunità.' },
      { property: 'og:image', content: 'https://archiviomisericordia.it/assets/img/archivio-misericordia-borgo-san-lorenzo.jpg' },
      { property: 'og:url', content: 'https://archiviomisericordia.it' },
      { property: 'og:type', content: 'website' }
    ]);
  }
}
